import { Component, ElementRef, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'lifedi-chip',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss']
})

export class ChipsComponent {
  @ViewChild('el') el: ElementRef;
  itemControl = new FormControl([]);
  @Input() selectedItem: string[];
  @Input() allItem: string[];
  @Input() field: string;
  @Output() outputSelected: EventEmitter<string[]> = new EventEmitter<string[]>()

  constructor() {

  }

  compareFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.EXPERTIE_ID === i2.EXPERTIE_ID : i1 === i2;
  }

  onChange() {
    this.outputSelected.emit(this.selectedItem);
  }
}
